module.exports = __webpack_public_path__ + "images/file_icons_v2/eps-9f67cc42b8db58e3e222f8619c5d2d21.svg";